import React from 'react';

import { MILLION_CATCHES } from '../../../constants/constants';

import { DownloadAppContent } from './components/DownloadAppContent';

export const DownloadAppVerticalCTA = ({ version }: { version: number }) => {
  switch (version) {
    case 1:
      return (
        <DownloadAppContent
          headingText="Download the Fishbrain app"
          subHeadingText={`Discover ${MILLION_CATCHES} million fishing spots, top baits, and more`}
        />
      );
    case 2:
      return <DownloadAppContent />;
    default:
      return <DownloadAppContent isLoading />;
  }
};
